import { LS2PAC_CONSTANTS } from "../../../js/main/constants";
import { TLCEXT } from "../../../js/lib/ext/Ext";

import { ApplicationData } from "./ApplicationData";
import { EventQueue } from "../../../js/lib/events/EventQueue";
import { LibraryThing } from "./widget/LibraryThingWidget";
import { ResourceUtils } from "./utils/resourceUtils";
import { LoginClientManager } from "./ClientManagers/LoginClientManager";
import { TLCLogger } from "../../../js/lib/logger";
// import { HarlemShake } from "../ls2kids/harlemShake";
import { TimeoutPageControl } from "./controls/timeoutPageControl";
import { TLCAnalyticsManager } from "./managers/TLCAnalyticsManager";
import { CustomerAnalyticsManager } from "./managers/CustomerAnalyticsManager";
import { HostSystemClientManager } from "./ClientManagers/HostSystemClientManager";

import * as React from "react";

// These imports all use IIFE to create instances on import
// they should by nature create sideEffects and not be removed by webpack during tree shaking
// the exported value from the IIFE should be cached, so we should not have issues importing multiple times
// generally speaking we should move away from event based managers like these that are not called directly
// toward something more explicit and clear to the developer
// it makes it really difficult to know how many of these managers are actually used at this point and need to be initialized
// At the very least, move the constant for the events listened/fired by the manager
// to a static property of the manager so the imports are required to fire the event
// some of these files may not be used but were part of the original bundle
import { GlobalConfigurationClientManager } from "./ClientManagers/GlobalConfigurationClientManager";
import { LanguageClientManager } from "./ClientManagers/LanguageClientManager";
import { Marc21DisplayClientManager } from "./ClientManagers/Marc21DisplayClientManager";
import { StationLocationClientManager } from "./ClientManagers/StationLocationClientManager";
import { ListsClientManager } from "./ClientManagers/ListsClientManager";
import { ResourceClientManager } from "./ClientManagers/ResourceClientManager";
import { StoredImageClientManager } from "./ClientManagers/storedImageClientManager";
import { LandingPageConfigClientManager } from "./ClientManagers/LandingPageConfigClientManager";
import { AvailabilityFactory } from "../availability/AvailabilityFactory";
import { EResourceCheckoutsClientManager } from "./ClientManagers/EResourceCheckoutsClientManager";
import { PrintAccountDataManager } from "./managers/PrintAccountDataManager";
import { RequestsClientManager } from "./ClientManagers/RequestsClientManager";

// jQuery plugin
import { AddCoverArt } from "./utils/addCoverArt";
import { App } from "@tlc/ls2pac/components/App";
import { renderWithoutShadow } from "@tlc/ls2pac/components/ShadowUtils";
import { AccountHolder } from "@tlc/ls2pac/components/Account";
import { TLCEventManager } from "src/main/resources/js/lib/events/EventManager";
import { LocationConfigurationHolder } from "@tlc/ls2pac/components/LocationConfiguration";
import { OBRSettingHolder } from "@tlc/ls2pac/components/OBRSettings";
import { GlobalConfigHolder } from "@tlc/ls2pac/components/GlobalConfig";

var _gaq = _gaq || [];
export const LS2PacMain = (function ($) {
  $.ajaxSetup({
    headers: {
      "Ls2pac-config-type": "pac",
      "Ls2pac-config-name": window["config"],
    },
  });

  return {
    //this is the initialization point for the app
    start: function () {


      var progressbarElement = $(
        "#" + LS2PAC_CONSTANTS.Ids.loadingProgress
      ).progressbar({ value: 10 });

      EventQueue.createQueue(
        [
          { eventToFire: LS2PAC_CONSTANTS.Events.onGetAvailableLanguages },
          { eventToFire: LS2PAC_CONSTANTS.Events.onGetLanguage },
          { funcWithCallback: async (callback) => {
            const {isAuthenticated, user} = await AccountHolder.fetchAccountData();
            return callback();
          } },
          { eventToFire: HostSystemClientManager.getSupportedFunctionalityEvent },
          {
            funcWithCallback: async function(callback) {
              await OBRSettingHolder.getConfig();
              callback();
            }
          },
          { eventToFire: LS2PAC_CONSTANTS.Events.onGetGlobalConfiguration },
          {
            funcWithCallback: async function (callback) {
              await GlobalConfigHolder.fetchGlobalConfig();
              callback();
            },
          },
          {
            funcWithCallback: async function (callback) {
              await LocationConfigurationHolder.fetchLocationConfiguration();
              callback();
            },
          },
          { eventToFire: LS2PAC_CONSTANTS.Events.onGetCurrentBranch },
          {
            funcWithCallback: function (callback) {
              LibraryThing.initConfig(ApplicationData.language, callback);
            },
          },
        ],
        function () {

          TLCLogger.log("done loading", ApplicationData);
          const {
            communityTrackingEnabled,
            customerTrackingEnabled,
            communityTrackingCode,
            customerTrackingCode,
          } = window;

          console.log("communityTrackingEnabled: ", communityTrackingEnabled);
          console.log("customerTrackingEnabled: ", customerTrackingEnabled);

          if (
            communityTrackingEnabled === true ||
            customerTrackingEnabled === true
          ) {
            if (communityTrackingEnabled === true) {
              TLCAnalyticsManager.getInstance({
                trackingCode: communityTrackingCode,
              });
            }
            if (customerTrackingEnabled === true) {
              CustomerAnalyticsManager.getInstance({
                trackingCode: customerTrackingCode,
              });
            }
          }

          TLCEXT.setBaseData({
            languageUtil: ApplicationData.language,
            resourceUtil: ResourceUtils,
            ls2pacConstants: LS2PAC_CONSTANTS,
            muiContainedButton: "TEMP_muiContainedButton",
            muiTextButton: "TEMP_muiTextButton",
            muiOutlinedButton: "TEMP_muiOutlinedButton",
            muiButtonAsLink: "TEMP_muiButtonAsLink",
          });

          TimeoutPageControl.init();

          $("#" + LS2PAC_CONSTANTS.Ids.mainLoader).fadeOut(300, function () {

            var divElement = document.createElement('div');
            divElement.id = 'react-app';
            document.body.insertBefore(divElement, document.body.firstChild);
            // mainContent.appendChild(divElement);
            renderWithoutShadow(<App></App>, divElement, ApplicationData.language);
            
          });

          // HarlemShake.doRelative = true;
          // HarlemShake.delay = 1000;
          // HarlemShake.elementsToApply =
          //   "#header_searchInput, form .searchBar, form a.advancedSearch, .searchButton, .page a, ul.nav a";
          // HarlemShake.mainDancerSelector = ".speech a";

          // HarlemShake.doHistory = function () {
          //   location.href = "/#section=home";
          // };

          // HarlemShake.init();
        },
        function (progress, total, current) {
          progressbarElement.progressbar("value", progress);
        }
      );

      /* Fix scaling issues with ipad/iphone */
      if (
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i)
      ) {
        var viewportmeta = document.querySelector('meta[name="viewport"]');
        if (viewportmeta) {
          viewportmeta.content =
            "width=device-width, minimum-scale=1.0, maximum-scale=1.0, initial-scale=1.0";
          document.body.addEventListener(
            "gesturestart",
            function () {
              viewportmeta.content =
                "width=device-width, minimum-scale=0.25, maximum-scale=1.6";
            },
            false
          );
        }
      }
    },
  };
})(jQuery);
